import React from "react";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import HeroImage from "../../assets/images/ProtectionPage.jpg";
import ServicesGrid from "../components/ServicesGrid";
import GridImage1 from "../../assets/images/Protection Page (2).jpg";
import GridImage2 from "../../assets/images/Protection Page (3).jpg";
import GridImage3 from "../../assets/images/Protection Page (4).jpg";
import GridImage4 from "../../assets/images/Protection Page (5).jpg";
import GridImage5 from "../../assets/images/Protection Page (6).jpg";
import FaqAccordion from "../components/FaqAccordion";
import Button from "../components/Button";
import { useNavigate } from "react-router-dom";

const faqItems = [
  {
    question: "Why do I need financial protection?",
    answer:
      "Financial protection can safeguard you and your family from unexpected life events, such as illness, disability, job loss, or death. It can act as a safety net to cover your financial commitments and help to prevent you from depleting your savings during difficult times",
  },
  {
    question: "What are the main types of financial protection?",
    answer:
      "There are several types of financial protection which include life insurance, income protection, critical illness cover, and mortgage payment protection.",
  },
  {
    question: "How do I know how much cover I need?",
    answer:
      " To determine the appropriate amount of coverage, you should calculate your monthly outgoings, review existing cover you have and assess other possible options.",
  },
  {
    question: "Can I rely on state benefits if I get sick?",
    answer:
      "For most people state benefits, such as Statutory Sick Pay, are insufficient to cover essential household expenses. While state support provides a basic level of assistance, a financial protection plan is usually necessary to maintain your family's quality of life and prevent reliance on your savings. ",
  },
  {
    question:
      "What is the difference between income protection and critical illness cover?",
    answer:
      "These two types of insurance are often confused, but they serve different purposes. Critical illness cover pays a single lump sum upon diagnosis of a specific serious illness covered by the policy. Income protection pays a regular monthly income if you cannot work due to illness or injury.",
  },
  {
    question: "How often should I review my financial protection?",
    answer:
      " Your need for financial protection will change throughout your life, so you should review your coverage regularly. Major life events, such as buying a house, getting married, having children, or changing jobs, are particularly good times to reassess your needs. A review ensures your coverage remains aligned with your current financial obligations and life stage",
  },
];
const items = [
  {
    title: "Life cover",
    description: [
      "Life cover provides a lump‑sum payout to your loved ones if you pass away during the policy term. It’s designed to give your family financial security at the most difficult time, helping them manage ongoing costs such as the mortgage, household bills, or future expenses. If you have dependents who rely on your income, life cover can offer essential long‑term support when it matters most.",
    ],
    image: GridImage1,
    imageAlt: "Keys exchange",
  },
  {
    title: "Critical Illness Cover",
    description: [
      "Critical illness cover pays out a tax‑free lump sum if you are diagnosed with a serious medical condition listed in your policy, such as cancer, heart attack, or stroke. It is designed to ease financial pressure during recovery, helping with mortgage payments, household bills, or time off work so you can focus on getting better. You will be guided through the various options available and we will assist you in selecting the right level of cover for your lifestyle and commitments.",
    ],
    image: GridImage2,
    imageAlt: "Meeting",
  },
  {
    title: "Income Protection",
    description: [
      "Income protection provides you with a regular monthly payment if you are unable to work due to illness or injury. It is designed to replace part of your income so you can keep up with essential bills—like your mortgage, utilities, and everyday living costs—while you recover. It offers long‑term financial stability and peace of mind, ensuring you are supported when your earnings stop. At Ava Rose Mortgages, we will assist you in selecting the right policy that complements your income and any existing protection you may have, to ensure you are fully covered.",
    ],
    image: GridImage3,
    imageAlt: "Mortgage discussion",
  },
  {
    title: "ACCIDENT & SICKNESS COVER",
    description: [
      "Accident and sickness cover provides a monthly benefit if you are unable to work due to an accident or illness. It is designed to help you keep up with essential bills—like your mortgage, rent, or everyday living costs—while you recover. This type of cover offers short‑term financial support, giving you breathing space when your income suddenly stops. At Ava Rose Mortgages, we will assist you in selecting the right policy that complements your income and any existing protection you may have, to ensure you are fully covered.",
    ],
    image: GridImage4,
    imageAlt: "Buy to let",
  },
  {
    title: "Business Protection",
    description: [
      "Business protection helps safeguard a company if a key person, business owner, or shareholder dies or becomes seriously ill. It provides a financial payout that can be used to keep the business running, replace vital skills, protect profits, or buy shares to maintain control. It’s designed to give stability and continuity during unexpected disruption.  You will be guided through the various options available and we will assist you in selecting the right level of cover to protect your business and provide financial security for those who depend on it.",
    ],
    image: GridImage5,
    imageAlt: "Business meeting",
  },
];

export function ProtectionPage() {
  const navigate = useNavigate();
  return (
    <>
      <Hero title={"Protection"} subtitle={""} backgroundImage={HeroImage} />
      <div
        className="text-button-container"
        style={{ maxWidth: "1200px", margin: "20px auto 10px auto" }}
      >
        <p>
          Ensuring you have the right protection in place can give you peace of
          mind during life's unexpected moments.
        </p>
        <p>
          Whether you are buying your first home, growing your family, or simply
          looking to safeguard your income, we’ll make sure you have the right
          protection in place to support your goals and future plans.
        </p>
        <p>
          At Ava Rose Mortgages, we will take the time to understand your
          personal circumstances, financial commitments, and long-term
          priorities before recommending any protection plan to you. Our advice
          will cover a wide range of insurance options, from life and critical
          illness cover to income protection and accident & sickness cover. We
          will ensure you understand how each type works, what it covers, and
          how it fits in with your budget and current and future lifestyle. With
          our bespoke guidance, you will be able to make informed choices that
          will keep you and your family protected when it matters most.
        </p>{" "}
        <Button
          text="Start your journey with us"
          onClick={() => navigate("/contact")}
        />
      </div>
      <ServicesGrid items={items} />
      <div className="text-button-container" style={{ maxWidth: "1200px", margin: "20px auto 10px auto" }}>
        <p style={{padding: "0.5rem"}}>
          Protection policies are subject to eligibility, medical underwriting,
          and provider terms.
        </p>
      </div>
      <FaqAccordion items={faqItems} />
    </>
  );
}

